import type { Feature } from '../types';
import { Region, FeatureName, ApplicationChannel } from '../config';

const grabpay: Feature = {
  featureName: FeatureName.GRABPAY,
  description: 'GrabPay configuration',
  enabledRegions: [Region.SG],
  enabledAppChannels: [ApplicationChannel.WEB],
  status: true,
};

export default grabpay;
